module.exports = __webpack_public_path__ + "img/c-en-27.57af0e66.png";